import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core'

import { LocalDate, LocalDateTime } from 'js-joda'

import { Fare } from 'app/fares/fares.interfaces'
import { EnvironmentService } from 'app/environment.service';
import { ResourceService } from '../resources/resource.service';
import { StepService } from '../steps/step.service';
import { SbEvent } from '../sb-event.emitter';
import { FormControl, FormGroup } from '@angular/forms';
import { LayoutState } from '../layout/layout-state';

@Component({
    selector: 'sbw-prev-next',
    templateUrl: './prev-next.component.html',
    styleUrls: ['./prev-next.component.css']
})
export class PrevNextComponent implements OnChanges {
    @Input() mode: Mode
    @Input() minDate: LocalDate
    @Input() maxDate: LocalDate
    @Input() disabledDates: LocalDate[]
    @Input() dateControl: FormControl
    @Input() previousText: string
    @Input() nextText: string
    @Input() textVisible: boolean = true
    @Input() allowSameDay: boolean

    public contentfulEditMode: boolean
    public isLoading: boolean
    public isQuoteLoading: boolean
    public resourceKey: string
    public visible: boolean = true
    public calculated: LocalDate

    modeEnum = Mode

    constructor(
        private environmentService: EnvironmentService,
        private resourceService: ResourceService,
        private events: SbEvent,
        private layoutState: LayoutState) {
    }

    ngOnInit() {
        this.layoutState.isLoading$.subscribe(x => this.isLoading = x)
        this.contentfulEditMode = this.environmentService.contentfulEditMode

        this.environmentService.contentfulEditModeChanged$
            .subscribe(enabled => {
                this.contentfulEditMode = enabled
            })

        this.loadResources()
    }

    private loadResources(): void {
        this.events.resourcesLoaded.subscribe(() => {
            if (!this.nextText) {
                this.resourceService.get('LATER').subscribe(resourceText => this.nextText = resourceText)
            }
            if (!this.previousText) {
                this.resourceService.get('EARLIER').subscribe(resourceText => this.previousText = resourceText)
            }
        }
        )
        this.resourceService.loadResources('Default', this.resourceService.getLocale(), ['Fares'])
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.dateControl.value) { return }
        if (!this.minDate || !this.maxDate) { return }
        if (!this.disabledDates) { return }

        this.mode === Mode.Prev ? this.setPrevious() : this.setNext()
        this.setVisible()
    }

    setNext(): void {
        let result: LocalDate
        let dateToExamine = this.dateControl.value.plusDays(1)

        this.disabledDates.forEach(x => {
            if (dateToExamine.isEqual(x)) {
                dateToExamine = dateToExamine.plusDays(1)
            }
        })

        if (dateToExamine.isEqual(this.maxDate) || (dateToExamine.isBefore(this.maxDate))) { result = dateToExamine }
        if (!result) { result = this.dateControl.value }

        this.calculated = result
    }

    setPrevious(): void {
        let result: LocalDate
        let dateToExamine = this.dateControl.value.minusDays(1)

        this.disabledDates.forEach(x => {
            if (dateToExamine.isEqual(x)) {
                dateToExamine = dateToExamine.minusDays(1)
            }
        })

        if (dateToExamine.isEqual(this.minDate) || (dateToExamine.isAfter(this.minDate))) { result = dateToExamine }
        if (!result) { result = this.dateControl.value }

        this.calculated = result
    }


    setVisible(): void {
        this.visible = true

        if (!this.allowSameDay) {
            if (this.mode === Mode.Prev) {
                if (this.dateControl.value.minusDays(1).isBefore(this.minDate)) {
                    this.visible = false
                }
            }

            if (this.mode === Mode.Next) {
                if (this.dateControl.value.plusDays(1).isAfter(this.maxDate)) {
                    this.visible = false
                }
            }
        }

        if (this.allowSameDay) {
            if (this.mode === Mode.Prev) {
                if (this.dateControl.value.minusDays(1).isBefore(this.minDate)) {
                    this.visible = false
                }
            }

            if (this.mode === Mode.Next) {
                if (this.dateControl.value.plusDays(1).isAfter(this.maxDate)) {
                    this.visible = false
                }

                if (this.dateControl.value.isEqual(this.maxDate)) {
                    this.visible = false
                }
            }
        }
    }

    public click() {
        this.dateControl.setValue(this.calculated)
    }
}

export enum Mode { Prev, Next }
export interface IOnPrevNext {
    mode: Mode
    value: LocalDateTime
}
